// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dashboard-snackbar[data-v-2f045df8]  .v-btn.v-btn--icon,.dashboard-snackbar[data-v-2f045df8]  .v-icon{color:inherit}.iphone-pwa-prompt[data-v-2f045df8] .v-snack__wrapper{padding-bottom:env(safe-area-inset-bottom)}.iphone-pwa-prompt .close[data-v-2f045df8]{position:absolute;right:12px;top:4px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
